var React = require('react');

var Dialog = require('../Dialog/Dialog');

class VideoMemberModal extends React.Component {
    constructor(props) {
        super(props);
    }
  render() {
    return (
      <div id={this.props.data.id} className="VideoMemberModal">
        <Dialog name="dialog-video-member-modal" additionalClass="c-dialog--narrow c-dialog--center">
          <p className="c-dialog__title">{this.props.data.title}</p>
          <div className="c-dialog__copy" dangerouslySetInnerHTML={{__html:this.props.data.text}}></div>
          <div className="c-dialog__actions">
            <p className="c-dialog__actions__action">
              <a href={this.props.data.loginUrl} className="c-button c-button--dark c-button--small c-button--full" rel="noopener external">{this.props.data.buttonText}</a>
            </p>
          </div>
        </Dialog>
      </div>
    );
  }
};

module.exports = VideoMemberModal;


// WEBPACK FOOTER //
// ./src/components/VideoMemberModal/VideoMemberModal.js